import { TableHeadingCell, withTableHeadingAccessibility, } from "./TableHeadingCell.mjs.mjs";
export const TableRowHeadingCell = withTableHeadingAccessibility(TableHeadingCell, { role: 'rowheader', scope: 'row', displayName: 'TableRowHeadingCell' });
//# sourceMappingURL=TableRowHeadingCell.mjs.mjs.map